import React from 'react';

// Simple static component with no animations
const StatItem = ({ icon, number, title }) => {
  return (
    <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
      <i className={`bi bi-${icon}`}></i>
      <div className="stats-item">
        <span className="static-counter">{number}</span>
        <p>{title}</p>
      </div>
    </div>
  );
};

const Stats = () => {
  const stats = [
    { icon: 'calendar4-week', number: 15, title: 'Years of Excellence' },
    { icon: 'people', number: 5000, title: 'Happy Users' },
    { icon: 'star-fill', number: 4, title: 'Google Rating' },
    { icon: 'building', number: 30, title: 'Channel Partners' }
  ];

  return (
    <section id="stats" className="stats section light-background">
      <div className="container">
        <div className="row gy-4 justify-content-center">
          {stats.map((stat, index) => (
            <StatItem 
              key={index} 
              icon={stat.icon} 
              number={stat.number} 
              title={stat.title} 
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats; 